export default "__VITE_ASSET__BtB19os2__"